import { render, staticRenderFns } from "./taskDay.vue?vue&type=template&id=228f0069&scoped=true&"
import script from "./taskDay.vue?vue&type=script&lang=js&"
export * from "./taskDay.vue?vue&type=script&lang=js&"
import style0 from "./taskDay.vue?vue&type=style&index=0&id=228f0069&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228f0069",
  null
  
)

export default component.exports